const CounterData01 = [
  {
    number: {
      text: "2530",
    },
    title: "Custom shortcodes",
    content: "Lorem ipsum is simply dummy text the printing typesetting",
  },
  {
    number: {
      text: "2000",
    },
    title: "Completed projects",
    content: "Lorem ipsum is simply dummy text the printing typesetting",
  },
  {
    number: {
      text: "1958",
    },
    title: "Working hours",
    content: "Lorem ipsum is simply dummy text the printing typesetting",
  },
];

const CounterData02 = [
  {
    number: {
      text: "2500",
    },
    title: "WORKING",
    content: "HOURS",
  },
  {
    number: {
      text: "3250",
    },
    title: "PHOTO",
    content: "CAPTURE",
  },
  {
    number: {
      text: "2800",
    },
    title: "WORK",
    content: "COMPLETED",
  },
  {
    number: {
      text: "2750",
    },
    title: "TELEPHONIC",
    content: "TALK",
  },
];

const CounterData03 = [
  {
    number: {
      text: "24",
    },
    title: "COUNTRIES",
  },
  {
    number: {
      text: "28",
    },
    title: "LANGUAGES",
  },
  {
    number: {
      text: "72",
    },
    title: "CHANNELS",
  },
  {
    number: {
      text: "92",
    },
    title: "BRANDS",
  },
];

const CounterData04 = [
  {
    number: {
      text: "220",
    },
    title: "PEOPLE",
  },
  {
    number: {
      text: "380",
    },
    title: "PROJECTS",
  },
  {
    number: {
      text: "700",
    },
    title: "CHANNELS",
  },
  {
    number: {
      text: "240",
    },
    title: "BRANDS",
  },
];

const CounterData05 = [
  {
    number: {
      text: "14",
      class:
        "text-gradient bg-gradient-to-r from-[#556fff] to-[#e66176] inline-block",
    },
    title: "Districts Covered",
    // content:"For creative design",
  },
  {
    number: {
      text: "152",
      class:
        "text-gradient bg-gradient-to-r from-[#556fff] to-[#e66176] inline-block",
    },
    title: "Blocks Covered",
  },
  {
    number: {
      text: "941",
      class:
        "text-gradient bg-gradient-to-r from-[#556fff] to-[#e66176] inline-block",
    },
    title: "Grama Panchayats Covered",
  },
  {
    number: {
      text: "87",
      class:
        "text-gradient bg-gradient-to-r from-[#556fff] to-[#e66176] inline-block",
    },
    title: "Municipalities covered ",
  },
  {
    number: {
      text: "6",
      class:
        "text-gradient bg-gradient-to-r from-[#556fff] to-[#e66176] inline-block",
    },
    title: "Corporations covered",
  },
  {
    number: {
      text: "23",
      class:
        "text-gradient bg-gradient-to-r from-[#556fff] to-[#e66176] inline-block",
    },
    title: "AEUs covered",
  },
];

export {
  CounterData01,
  CounterData02,
  CounterData03,
  CounterData04,
  CounterData05,
};
